import { clearEpAwareSignupSessionId } from "./utils";

export const shouldAllowEpAwareVerification = ({
  category = "complete_protection",
  isQuestionByPass = false,
  skipVerification = false,
  skipVerificationPopupOpen = false,
  verificationMethod = "choose",
  isExplicitIdChoice = false,
  requireExplicitIdChoice = true,
} = {}) => {
  const isCompleteProtection = category === "complete_protection";
  const isExplicitId =
    isExplicitIdChoice || verificationMethod === "id";

  if (requireExplicitIdChoice && !isExplicitId) {
    return false;
  }

  if (
    isCompleteProtection &&
    (isQuestionByPass || skipVerification || skipVerificationPopupOpen)
  ) {
    return false;
  }

  return true;
};

export const canOfferEpAwareIdVerification = (options = {}) =>
  shouldAllowEpAwareVerification({
    ...options,
    requireExplicitIdChoice: false,
  });

export const clearEpAwareSignupArtifactsOnSkip = () => {
  clearEpAwareSignupSessionId();
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem("signupVerificationMethod");
  }
};
